import { Box, Card, Stack, Typography } from '@mui/material';

import colors from '../../../../constants/colors';

interface PaymentPageProps {
  pageTitle: string;
}

const PaymentPage = ({
  children,
  pageTitle,
}: React.PropsWithChildren<PaymentPageProps>) => {
  return (
    <Box
      data-testid="addPaymentMethodPage"
      sx={{
        display: 'flex',
        flex: 1,
        width: 1,
        flexDirection: 'column',
        minHeight: '100%',
        backgroundColor: colors.csaaGray,
        px: { mobile: 2, desktop: 19.5 },
        pb: 3,
        pt: { mobile: 3, desktop: 9 },
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontWeight: 500,
          fontSize: { mobile: 33, tablet: 44 },
          pb: { mobile: 0.5, tablet: 1 },
          lineHeight: { mobile: '32px', tablet: '56px' },
        }}
      >
        {pageTitle}
      </Typography>
      <Card
        component={Stack}
        spacing={2}
        sx={{
          borderRadius: 2.5,
          mt: 3,
          px: {
            mobile: 2,
            tablet: 3,
            desktop: 5,
          },
          py: {
            mobile: 3,
            desktop: 5,
          },
          height: 'auto',
          boxShadow: '0px 4px 8px 0px rgba(25, 30, 43, 0.08)',
        }}
      >
        {children}
      </Card>
    </Box>
  );
};

export default PaymentPage;
